export default __webpack_public_path__ + "static/media/mobileimage2.dbb1a7c2.png";